export interface Appointment {
    id: string;
    patientName: string;
    date: string; // YYYY-MM-DD
    time: string; // HH:mm
    type: 'Checkup' | 'Cleaning' | 'Emergency' | 'Consultation';
    status: 'Confirmed' | 'Pending' | 'Cancelled';
    phone?: string;
  }
  
  export interface DaySchedule {
    date: string;
    slots: { time: string; available: boolean }[];
  }
  
  export enum AgentStatus {
    DISCONNECTED = 'disconnected',
    CONNECTING = 'connecting',
    LISTENING = 'listening',
    SPEAKING = 'speaking',
    THINKING = 'thinking',
    ERROR = 'error'
  }
  
  export interface MessageLog {
    id: string;
    source: 'user' | 'agent' | 'system';
    text: string;
    timestamp: Date;
  }
  